import { PromotionPolicy } from '@/policies';
import { auth } from '@/services';

(function (angular) {
    'use strict';

    angular.module('app')
        .controller('promotionsController', promotionsController);

    promotionsController.$inject = [
        '$location',
        'PostsSearchApi',
        'promotionsPayload',
        'PromotionsApi',
        'Promotions',
        'PromotionsTellMeMoreApi',
        'alerts',
        '$scope'
    ];

    function promotionsController(
        $location,
        PostsSearchApi,
        promotionsPayload,
        PromotionsApi,
        Promotions,
        PromotionsTellMeMoreApi,
        alerts,
        $scope
    ) {
        const vm = this;
        
        // properties
        vm.permissionChecks = {
            canCreate: PromotionPolicy.canCreate(auth.user()),
        };
        vm.isLoading = false;
        vm.promotions = angular.copy(promotionsPayload);
        
        vm.promotions.data = [];
        vm.categories = [].concat($location.search()['categories[]'] || []).map(id => parseInt(id));
        vm.filters = {
            "categories[]": vm.categories,
            page: 1,
            page_size: vm.promotions.per_page,
            status: 'approved',
            title: '',
            search: '',
            starts_at_to: new Date().toDateString(),
            ends_at_from: new Date().toDateString(),
        };

        // methods
        vm.createPromotion = createPromotion;
        vm.getPromotions = getPromotions;
        vm.orderPromotions = orderPromotions;
        vm.onEdit = onEdit;
        vm.onCategoryChange = onCategoryChange;
        vm.searchPromotions = searchPromotions;
        vm.tellMeMore = tellMeMore;
        vm.loadMore = loadMore;

        // Convert each item from the DOM dump to a resource model
        angular.forEach(promotionsPayload.data, function (item) {
            vm.promotions.data.push(new PromotionsApi(item).transform());
        });

        /**
         * Shows the create promotion post modal
         *
         * @param {Event=}
         * @return {void}
         */
        function createPromotion(event?: Event) {
            if (event) {
                event.preventDefault();
            }

            Promotions.managePromotion().result.then(promotion => {
                if (promotion.status === 'approved') {
                    vm.promotions.data.unshift(promotion);
                }
            });
        }

        /**
         * On Edit callback
         *
         * @param {iPromotion}  updatedPromo  The updated promo
         */
        function onEdit(updatedPromo) {
            // Find and update the news
            angular.forEach(vm.promotions.data, (promotion, index) => {
                if (promotion.id === updatedPromo.id) {
                    if (updatedPromo.deleted) {
                        getPromotions();
                    } else {
                        vm.promotions.data[index] = updatedPromo;
                    }

                }
            });
        }
        
        /**
         * Updates filters and refreshes the events.
         * Called by the order events select control.
         *
         * @return {void}
         */
        function orderPromotions() {
            angular.merge(vm.filters, vm.selectedOrderFilter, vm.orderdateFilter, vm.selectedOrderdateFilter);
            vm.filters.label = null;
            getPromotions();
        }

        /**
         * Retrieves promotions from the API
         * @return {void}
         */
        function getPromotions() {
            vm.isLoading = true;

            PromotionsApi.get(vm.filters, function handleGetPromotionsResponse(response) {
                vm.promotions = response;
                
                vm.isLoading = false;
            }, function handleGetPromotionsError() {
                vm.isLoading = false;
            });
        }
        
        /**
         * Load more promotions
         *
         * @return {void}
         */
        function loadMore() {
            vm.filters.page_size = vm.filters.page_size + 6;
            
            getPromotions();
          };

        /**
         * Called when categories have changed.
         * @param categories
         */
        function onCategoryChange(categories: string[]): void {
            vm.categories = categories;
            vm.filters["categories[]"] = categories;

            vm.getPromotions();
        }

        function searchPromotions() {
            if (!vm.filters.search || vm.filters.search === '') {
                vm.getPromotions();
                return;
            }

            vm.isLoading = true;

            // vm.$location.search('categories[]')
            PostsSearchApi
                .get(
                    { q: vm.filters.search, type: 'promotion' },
                    (response: any) => {
                        vm.promotions.data = response.results;
                        vm.isLoading = false;
                        $('html, body').animate({ scrollTop: $('#promotions-title').offset().top - 20 });
                    },
                    () => this.isLoading = false,
                );
        }

        function tellMeMore() {
            console.log('ooh tell me more!')
            PromotionsTellMeMoreApi.post({
                id: vm.promotion.id,
            }, function handleTellMeMoreResponse() {
                vm.promotion.told = true;
                alerts.emit({
                    theme: 'success',
                    title: 'Offer Claimed',
                    messages: ['A message has been sent to the owner of this offer. Someone will be in touch shortly to assist you with the redemption of this offer.']
                    });
            }, function handleTellMeMoreError () {
                vm.promotion.told = false;

                alerts.emit({
                    theme: 'error',
                    title: 'There was an issue claiming your promotion, please try again',
                });
            });
        }
    }

}(angular));
